import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UrlIdResolverService } from 'app/modules/shared/services/url-id-resolver.service';
import { FeatureRepository } from 'app/state/feature.repository';
import { FeatureService } from 'app/state/feature.service';
import { Tenant, TenantsRepository } from 'app/state/tenants.repository';
import { TenantsService } from 'app/state/tenants.service';
import { GeneralDataRepository } from '../../../../helpers/repository/general-data.repository';
import { TrackRender } from 'app/shared/front-perfomance';
import { MessageText, ToastService } from 'app/helpers/services/toastService';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BreadcrumbService } from 'app/modules/shared/components/breadcrumb/breadcrumb.service';

const TABS_OPTIONS = [
  { value: 'home', label: 'Home' },
  { value: 'information', label: 'Information' },
  { value: 'spDescription', label: 'SP Description' },
  { value: 'description', label: 'Description' },
  { value: 'tags', label: 'Tags' },
  { value: 'folders', label: 'Folders' },
  { value: 'teams', label: 'Teams' },
  { value: 'departments', label: 'Departments' },
  { value: 'checklists', label: 'Checklists' },
  { value: 'msGraphOptions', label: 'Microsoft Graph' },
  { value: 'emailTemplates', label: 'Email Templates' },
];

@UntilDestroy()
@TrackRender()
@Component({
  selector: 'app-tenants-create-page',
  templateUrl: './tenants-create-page.component.html',
  styleUrls: ['./tenants-create-page.component.scss'],
  standalone: false,
})
export class TenantsCreatePageComponent implements OnInit {
  tenant$: Observable<Tenant> | null = null;
  tenant: Tenant | null = null;
  id?: string;
  submitErrors: string[] | null = null;
  isLoading: boolean = true;

  tenantId?: string | null;

  selectedTab: string = 'home';
  tabsOptions = TABS_OPTIONS;

  constructor(
    private tenantService: TenantsService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private featureService: FeatureService,
    public featureRepo: FeatureRepository,
    private sidebarRepo: GeneralDataRepository,
    public toastService: ToastService,
    private breadcrumbService: BreadcrumbService,
  ) {}

  ngOnInit(): void {
    this.activatedRoute.paramMap
      .pipe(untilDestroyed(this))
      .subscribe((params) => {
        var idFromrout = params.get('id');
        this.tenantId = idFromrout !== 'new' ? idFromrout : null;
        if (idFromrout && idFromrout !== 'new') {
          this.tenantService.loadOne(idFromrout).subscribe((tenant) => {
            this.tenant = tenant;
            this.id = tenant.id;
            this.tenantId = tenant.id;
            this.isLoading = false;
            // Store the entity name directly; transloco passes unknown keys through.
            this.breadcrumbService.setDynamicLabel('tenantName', tenant.name);
          });
        } else {
          // New tenant: store the translation KEY so it resolves reactively.
          this.isLoading = false;
          this.breadcrumbService.setDynamicLabel('tenantName', 'createTenant');
        }
      });

    this.loadData();
  }

  loadData() {
    var currTenantId = localStorage.getItem('activeTenantId');
    if (!currTenantId) {
      currTenantId = 'empty';
    }
    this.featureService.loadFeatures(currTenantId).subscribe(() => {
      this.isLoading = false;

      setTimeout(() => {
        console.log('APP_READY_TenantPage');
      }, 3000);
    });
  }

  createTenant(tenant: Partial<Tenant>) {
    this.submitErrors = null;
    let updateResult: Observable<Tenant> | undefined;

    if (!this.id) {
      updateResult = this.tenantService.add(tenant);
    } else if (this.id) {
      updateResult = this.tenantService.update(this.id, tenant);
    }

    if (updateResult) {
      updateResult.subscribe({
        complete: () => {
          this.sidebarRepo.updateAllGeneralData(true);
          this.toastService.showSuccess(MessageText.saved);
        },
        error: (data) => (this.submitErrors = data),
      });
    }
  }

  formatText(text: string): string {
    return text.toLowerCase().replace(/\s+/g, '-');
  }

  getInitials(name: string): string {
    return name
      .split(' ')
      .slice(0, 2)
      .map((word) => word[0].toUpperCase())
      .join('');
  }

  changeTabs(tab: string) {
    this.selectedTab = tab;
  }
}
